import notoAngryReaction from "../../../assets/images/emojis/animated/noto-angry.webp";
import notoApplauseReaction from "../../../assets/images/emojis/animated/noto-applause.webp";
import notoClapReaction from "../../../assets/images/emojis/animated/noto-clap.webp";
import notoCryReaction from "../../../assets/images/emojis/animated/noto-cry.webp";
import notoDislikeReaction from "../../../assets/images/emojis/animated/noto-dislike.webp";
import notoGreetingReaction from "../../../assets/images/emojis/animated/noto-greeting.webp";
import notoHeartReaction from "../../../assets/images/emojis/animated/noto-heart.webp";
import notoLaughReaction from "../../../assets/images/emojis/animated/noto-laugh.webp";
import notoLikeReaction from "../../../assets/images/emojis/animated/noto-like.webp";
import notoSmileReaction from "../../../assets/images/emojis/animated/noto-smile.webp";
import notoStrengthReaction from "../../../assets/images/emojis/animated/noto-strength.webp";
import notoThankYouReaction from "../../../assets/images/emojis/animated/noto-thank-you.webp";
import notoTiredReaction from "../../../assets/images/emojis/animated/noto-tired.webp";
import notoTongueReaction from "../../../assets/images/emojis/animated/noto-tongue.webp";
import notoTriumphReaction from "../../../assets/images/emojis/animated/noto-triumph.webp";
import notoVictoryReaction from "../../../assets/images/emojis/animated/noto-victory.webp";
import notoWaveReaction from "../../../assets/images/emojis/animated/noto-wave.webp";
import notoWinkReaction from "../../../assets/images/emojis/animated/noto-wink.webp";
import notoWorriedReaction from "../../../assets/images/emojis/animated/noto-worried.webp";
import notoYumReaction from "../../../assets/images/emojis/animated/noto-yum.webp";

const ANIMATED_REACTION_ASSETS = {
  angry: notoAngryReaction,
  applause: notoApplauseReaction,
  clap: notoClapReaction,
  cry: notoCryReaction,
  dislike: notoDislikeReaction,
  greeting: notoGreetingReaction,
  heart: notoHeartReaction,
  laugh: notoLaughReaction,
  like: notoLikeReaction,
  smile: notoSmileReaction,
  strength: notoStrengthReaction,
  thank_you: notoThankYouReaction,
  tired: notoTiredReaction,
  tongue: notoTongueReaction,
  triumph: notoTriumphReaction,
  victory: notoVictoryReaction,
  wave: notoWaveReaction,
  wink: notoWinkReaction,
  worried: notoWorriedReaction,
  yum: notoYumReaction
};

export function getParticipantLayoutAnimatedReactionSrc(emojiId) {
  return ANIMATED_REACTION_ASSETS[emojiId] || null;
}
